import React from 'react';
export function Footer() {
  return <footer className="w-full px-4 py-8 text-base leading-6 border-t border-yellow-400/20" style={{
    backgroundColor: '#0a0a0a',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-150">
      <div className="mx-auto max-w-3xl text-center" data-id="element-151">
        {/* Logo */}
        <div className="mb-3 text-xl font-black tracking-[2.4px] text-yellow-400" data-id="element-152">
          🧠 CONSTRUYE PROGRESO™
        </div>

        {/* Tagline */}
        <p className="mx-auto max-w-[576px] text-xs leading-[20px] text-gray-400 m-0 mb-3" data-id="element-153">
          El sistema de foco y ejecución N°1 para emprendedores en Argentina.
        </p>

        <p className="text-xs italic text-gray-500 m-0 mb-5" data-id="element-154">
          Porque recuperar el control de tu atención no debería costarte toda la
          fuerza de voluntad que no tenés.
        </p>

        {/* Contact Info */}
        <div className="mb-5 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-xs text-gray-400" data-id="element-155">
          <span data-id="element-156">📧 construyeprogresoo@gmail.com</span>
          <span className="hidden sm:block text-gray-700" data-id="element-157">•</span>
          <span data-id="element-158">📲 @construyeprogresoo</span>
          <span className="hidden sm:block text-gray-700" data-id="element-159">•</span>
          <span data-id="element-160">🌐 www.construyeprogreso.com</span>
        </div>

        {/* Divider */}
        <div className="mb-5 h-px bg-yellow-400/20" data-id="element-161" />

        {/* Copyright */}
        <p className="text-[10px] text-gray-500 m-0 mb-1" data-id="element-162">
          © Construye Progreso™ 2025 — Todos los derechos reservados.
        </p>
        <p className="text-[10px] text-gray-600 m-0 mb-4" data-id="element-163">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}